import React, { useRef, useState, useEffect, useCallback } from 'react';

interface Video {
  title: string;
  videoId: string;
  duration: string;
}

const videos: Video[] = [
  { title: 'Almanya Aile Birleşimi Vizesi', videoId: 'dt5_DsOwgYc', duration: '10:45' },
  { title: 'Almanya Ulusal Vize Başvurusu', videoId: '8YARKHbtUTk', duration: '18:13' },
  { title: 'Almanca Bilmediğimden Başıma Gelenler', videoId: 'JX9ukkSv9Ew', duration: '21:08' },
  { title: "Almanya'da Geçen 6 Yıl", videoId: '9xp7Ba7Mr4k', duration: '14:22' },
  { title: 'Kariyer Değişikliği ve UX Designer', videoId: 'fcU6cDcwEtw', duration: '12:30' },
  { title: "ODTÜ'lü Mühendisin Tecrübeleri", videoId: 'BsSD969hozY', duration: '16:45' },
  { title: 'Çocuk İle Göç Etmek', videoId: 'N2sbhH-67kQ', duration: '13:18' },
  { title: "Almanya'da Yaşam GÜVEN", videoId: '31pSF6b53uM', duration: '15:00' },
];

const YouTubeSection: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const updateButtons = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    updateButtons();
    const el = trackRef.current;
    if (!el) return;
    el.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    return () => {
      el.removeEventListener('scroll', updateButtons);
      window.removeEventListener('resize', updateButtons);
    };
  }, [updateButtons]);

  const scrollByStep = (direction: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector<HTMLElement>('.youtube-card');
    const step = card ? card.offsetWidth + 24 : el.clientWidth * 0.8;
    el.scrollBy({ left: step * direction, behavior: 'smooth' });
  };

  return (
    <section id="sosyal-medya" className="youtube-section social-media-home-section">
      <div className="container">
        <h2 className="section-title">Bizi Sosyal Medyadan Takip Edin</h2>
        <div className="social-platform-heading">
          <span className="social-platform-icon social-platform-icon-youtube" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <rect x="2.5" y="5.5" width="19" height="13" rx="4" stroke="currentColor" strokeWidth="1.8" />
              <path d="M10 9l5 3-5 3V9z" fill="currentColor" />
            </svg>
          </span>
          <h3 className="social-platform-title">YouTube</h3>
          <a className="social-platform-handle" href="https://www.youtube.com/@almanyayagoc" target="_blank" rel="noopener noreferrer">
            @almanyayagoc <span aria-hidden="true">↗</span>
          </a>
        </div>
        <p className="youtube-description">
          Göç hazırlığından yerleşime kadar kendi yolculuğumda edindiğim tüm tecrübeleri YouTube kanalımda
          paylaşıyorum. Videolarımı izleyerek göç sürecinde nelerle karşılaşabileceğinize dair fikir edinebilir
          ve kendi hazırlıklarınızı daha bilinçli bir şekilde yapmak için deneyimlerimden yararlanabilirsiniz.
        </p>
        <div className="youtube-carousel">
          <button
            type="button"
            className="youtube-arrow youtube-arrow-prev"
            onClick={() => scrollByStep(-1)}
            disabled={!canPrev}
            aria-label="Önceki videolar"
          >
            <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 3L3 19L19 35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="youtube-grid" ref={trackRef}>
          {videos.map((video) => (
            <a
              key={video.videoId}
              href={`https://www.youtube.com/watch?v=${video.videoId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-card"
            >
              <div className="youtube-thumbnail">
                <img
                  src={`https://i.ytimg.com/vi/${video.videoId}/maxresdefault.jpg`}
                  alt={video.title}
                  loading="lazy"
                />
                <div className="youtube-play-overlay" aria-hidden="true">
                  <svg viewBox="0 0 40 40" width="40" height="40" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="18.5" fill="none" stroke="rgba(255,255,255,0.95)" strokeWidth="2" />
                    <path d="M16.5 13v14l11-7z" fill="rgba(255,255,255,0.95)" />
                  </svg>
                </div>
                <span className="youtube-duration">{video.duration}</span>
              </div>
            </a>
          ))}
          </div>
          <button
            type="button"
            className="youtube-arrow youtube-arrow-next"
            onClick={() => scrollByStep(1)}
            disabled={!canNext}
            aria-label="Sonraki videolar"
          >
            <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3L19 19L3 35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <div className="youtube-channel-link">
          <a
            href="https://www.youtube.com/@almanyayagoc"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-teal"
          >
            Tüm Videolar
          </a>
        </div>
      </div>
    </section>
  );
};

export default YouTubeSection;
